window.AjaxPostRequest = function (url, data, callback) {
    $.post(url,JSON.stringify(data))
        .done(callback)
        .fail(callback)
}


// WEBPACK FOOTER //
// ./resources/assets/website/scripts/ajax-post.js